<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $tc('messages.practice_races', 2),
                        href: meta.links.race_index,
                    },
                    {
                        name: $tc('messages.practice_races', 1),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:flex justify-between">
            <div class="flex flex-wrap gap-2">
                <AppButton v-for="group in meta.links.groups" :key="group.id" :href="group.url" size="sm">
                    {{ group.name }}
                </AppButton>
            </div>

            <div>
                <AppButton v-if="meta.links.edit" :href="meta.links.edit">
                    {{ $t('messages.edit') }}
                </AppButton>
                <AppButton v-else :href="meta.links.create" desired-action>
                    {{ $t('messages.create') }}
                </AppButton>
            </div>
        </div>

        <div class="mt-5">
            <PracticeRace :practice-race="practiceRace" :factions="factions" />
        </div>

        <div class="mt-5 flex flex-wrap gap-2">
            <BadgePill v-for="tag in meta.info.tags" :key="tag.id">
                {{ tag.name }}
            </BadgePill>
        </div>

        <div class="mt-5">
            <PracticeRaceDetails :details="practiceRace.details" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import PracticeRace from '@/Pages/Teacher/Gamification/Groups/PracticeRace/partials/PracticeRace.vue';
import BadgePill from '@/components/BadgePill.vue';
import AppButton from '@/components/AppButton.vue';
import PracticeRaceDetails from './partials/PracticeRaceDetails.vue';

export default {
    components: {
        PracticeRaceDetails,
        AppButton,
        BadgePill,
        PracticeRace,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'practiceRace', 'factions'],
};
</script>
